<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';
import { anykrowdApi } from '@/api/anykrowdApi';

// Init
const route = useRoute();
const qrCode = route.params.id.toString();

// onMountedHook
onMounted(async () => {
	if (qrCode) {
		try {
			const { data } = await anykrowdApi.post(`/rfid-tags/merge-qr/${qrCode}`, false);
		} catch (error) {
			console.log(error);
		}

		await router.push({ path: `/rfid` });
	}
});
</script>

<template>
	<div></div>
</template>

<style scoped></style>
